/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Moderationcolumnreported2Inputs */

const en_moderationcolumnreported2 = /** @type {(inputs: Moderationcolumnreported2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reported`)
};

const de_moderationcolumnreported2 = /** @type {(inputs: Moderationcolumnreported2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gemeldet am`)
};

/**
* | output |
* | --- |
* | "Reported" |
*
* @param {Moderationcolumnreported2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const moderationcolumnreported2 = /** @type {((inputs?: Moderationcolumnreported2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Moderationcolumnreported2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_moderationcolumnreported2(inputs)
	return de_moderationcolumnreported2(inputs)
});
export { moderationcolumnreported2 as "moderationColumnReported" }